import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import queryString from "query-string-for-all";
import { I18n } from "@lingui/react";
import { t, Trans } from "@lingui/macro";
import {
  Thirds,
  Left,
  Right,
  Center,
  DropdownMenu,
  Search,
  Button,
  spacing,
  ControlGroup,
  Plus,
} from "@conserveit/blocks";
import ColumnSelect from "../../../../containers/_BETA/ActionsMenus/ColumnSelect";
import SortSelect from "../../../../containers/_BETA/ActionsMenus/SortSelect";
import {
  ACTION_STATUSES,
  CLOSED_ACTIONS_START_DATE,
} from "../../../../redux/modules/_BETA/issues";
import { Exporter } from "../../../Exporter";
import { getActionsExportData } from "../../utils";

export const StyledThirds = styled(Thirds)`
  margin-bottom: ${spacing.default};
`;

export const SEARCH_KEY = "actionsSearch";

export const options = [
  {
    value: CLOSED_ACTIONS_START_DATE.LAST_12_MONTHS,
    label: "Last 12 months",
  },
  {
    value: CLOSED_ACTIONS_START_DATE.LAST_24_MONTHS,
    label: "Last 24 months",
  },
  {
    value: CLOSED_ACTIONS_START_DATE.ALL_TIME,
    label: "All time",
  },
];

const ActionBar = ({
  initialSearch,
  onSearchStringChange,
  data,
  noResults,
  hideEdits,
  history,
  handleClosedActionsTimeFrameChange,
  status,
}) => {
  const qs = queryString.parse(history.location.search);
  const currentStartDate = qs.closedOnStartDate
    ? Number(qs.closedOnStartDate)
    : CLOSED_ACTIONS_START_DATE.LAST_12_MONTHS;

  return (
    <I18n>
      {({ i18n }) => (
        <StyledThirds>
          <Left>
            <ControlGroup tight>
              <Button
                additive
                hidden={hideEdits}
                thin
                onClick={() => history.push("/actions/add")}
                icon={<Plus small />}
              >
                <Trans id="actions.add_action">Add Action</Trans>
              </Button>
              {data.length > 0 && !noResults && (
                <Exporter
                  data-cy="export-action"
                  appearance="outline"
                  rawData={data}
                  fileName="Actions.csv"
                  dataFormatter={getActionsExportData}
                >
                  Export
                </Exporter>
              )}
            </ControlGroup>
          </Left>

          <Center>
            <Search
              data-testid="actionBar-search"
              sessionKey={SEARCH_KEY}
              initial={initialSearch}
              data={data}
              onSearch={onSearchStringChange}
              defaultField="valueString"
              indexId="searchId"
              placeholder={i18n._(
                t(
                  "ticket_search.placeholder"
                )`Filter tickets e.g. ‘boiler plant’`
              )}
              thick
            />
          </Center>

          <Right>
            <SortSelect />
            {status === ACTION_STATUSES.closed && (
              <DropdownMenu
                right
                trigger="History"
                value={currentStartDate}
                onSelect={(option) =>
                  handleClosedActionsTimeFrameChange(option)
                }
                options={options}
              />
            )}
            <ColumnSelect />
          </Right>
        </StyledThirds>
      )}
    </I18n>
  );
};

ActionBar.propTypes = {
  onSearchStringChange: PropTypes.func.isRequired,
  handleClosedActionsTimeFrameChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  noResults: PropTypes.bool,
  status: PropTypes.string,
};

export default ActionBar;
